module.exports = __webpack_public_path__ + "img/oncourse-no-text.fa41a933.svg";